import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {  ActionRequiredComponent } from './action.component';
import { MainAuthGuard } from '../../../_shared/guards/main-auth-guard.service';
import { MainPermissionGuard } from '../../../_shared/guards/main-permission-guard.service';

const routes: Routes = [
  {path: 'action-required', component: ActionRequiredComponent, canActivate: [MainAuthGuard, MainPermissionGuard],},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class ActionRequiredComponentRoutingModule {
}